import { render } from "./TeamProfits.vue?vue&type=template&id=b6b433f2&scoped=true"
import script from "./TeamProfits.vue?vue&type=script&lang=js"
export * from "./TeamProfits.vue?vue&type=script&lang=js"

import "./TeamProfits.vue?vue&type=style&index=0&id=b6b433f2&lang=scss&scoped=true"

import exportComponent from "E:\\LEIGH_STORE\\PROJECTS\\2-PROJECTS\\6-PIYOOK\\ICS-Digital\\1-Dominic-Projects\\7-football-earnings\\5-website\\footy-earnings\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6b433f2"]])

export default __exports__